export default "__VITE_ASSET__sl7_nVYv__"